import { createFusionTheme, TSITheme } from '@fusion/saas-components-v3'
import '@fusion/saas-components-v3/theme/tsi'

const globalTheme = TSITheme
const fusionTheme = createFusionTheme(globalTheme)

export { globalTheme, fusionTheme }
